import RolesChecker from 'features/customer/components/RolesChecker';
import SelfReadingFormSection from 'features/requirements/sections/requirementFormTypes/selfReadingForm/SelfReadingFormSection';
import React from 'react';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import ContractDetailLayoutPage from './ContractDetailLayoutPage';
import { getContractDetailRootRoute } from 'features/shared/helpers/routeHelper';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { useTranslation } from 'react-i18next';
import { isEnabledCustomForm } from 'features/requirements/helpers/requirementTypeHelper';

interface Props {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const CreateSelfReadingPage = ({ contract, contractEnergy }: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation(["contracts\\contracts"]).t;

  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[
        { text: tModules("selfReadings.title"), to: getContractDetailRootRoute(contract.contractId!, "self-readings") },
        { text: tModules("createSelfReadingPage.title") }
      ]}
    >
      <RenderWrapper isVisible={() => isEnabledCustomForm("ZADANISAMOODECTU")}>
        <RolesChecker enabledRoles="Contributor">
          <SelfReadingFormSection 
            useOutsideOfRequirements 
            sendButtonTitle={tLabels("createSelfReadingPage.sendSelfReading")}
            selectedContractId={contract.contractId}
          />
        </RolesChecker>
      </RenderWrapper>
    </ContractDetailLayoutPage>
  )
}

export default CreateSelfReadingPage;
